// Shared design tokens for the standalone signup app (it renders outside the
// main app's ThemeProvider, so pages style themselves with these constants).

export const signupPalette = {
  primary: {
    main: '#242F40',
    dark: '#1A2230',
    contrastText: '#FFFFFF',
  },
  secondary: {
    main: '#3A475C',
    dark: '#2A3445',
    contrastText: '#FFFFFF',
  },
  third: {
    main: '#239AA4',
    dark: '#1E7F88',
    light: '#4DBBC4',
    contrastText: '#FFFFFF',
  },
}

export const signupCardSx = {
  width: '100%',
  borderRadius: 5,
  border: '1px solid',
  borderColor: 'rgba(36,47,64,0.10)',
  boxShadow: '0 18px 50px rgba(36,47,64,0.10)',
  bgcolor: '#FFFFFF',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
}

// The Business Subscription Agreement is accepted on the same screen as the
// checkout button, so it shares the payment step rather than having its own.
export const SIGNUP_STEPS = [
  'Your details',
  'Choose plan',
  'Verify email',
  'Agree & pay',
  'Ready',
]
